import { LoanState, Privacy } from "../loan.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";

export const privacyReducer = (
  state: LoanState,
  action: PayloadAction<Privacy>,
) => {
  state.privacy = {
    ...state.privacy,
    ...action.payload,
  };
};
